import { render, staticRenderFns } from "./AddBulkCustomer.vue?vue&type=template&id=107fd73b&"
import script from "./AddBulkCustomer.vue?vue&type=script&lang=js&"
export * from "./AddBulkCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports